<div id="news-dialog" *ngIf="news.length">
    <div id="news-dialog-inner-cont" class="cont-width">
        <span id="close" (click)="close()" tabindex="1" (keydown.escape)="close()"><mat-icon>close</mat-icon></span>
        <div id="news-img-cont" *ngIf="news[0].image1_id">
            <img [src]="restApiService.FILE_URL + news[0].image1_id">
        </div>
        <div id="news-img-cont" *ngIf="news[0].safeUrl">
            <img [src]="news[0].safeUrl">
        </div>
        <div id="news-content" [innerHTML]="currentHTML()"></div>
    </div>
</div>